import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// mui
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import "./styles/globals.css";
import Theme from "./styles/theme/index.js";

// react route
import { BrowserRouter } from "react-router-dom";

// toastify
import ToastStyledContainer from "./components/ToastStyledContainer";

// redux
import { Provider } from "react-redux";
import { store } from "./store";

// translation
import "./translation/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <ToastStyledContainer />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
